import React, { useState, useEffect } from 'react'
import PositionsWrapper from './positions/PositionsWrapper'
import Text from './text/Text'
import ChipSwiper from './swiper/Swiper'
import BetButtons from './betButtons/BetButtons'
import {
  formatThousandWithDecimals,
  heplerChip,
  sumAA,
} from './helpers/helperChip'
import { helperUndo } from './helpers/helperUndo'
import { useUpdateHistory } from './helpers/updateHistory'
import { helperClearStake } from './helpers/helperClearStakeOnLongPress'
import { useText } from './text/helpers/useText'
import { FOOTER_PROPS } from './interface'

function Footer({
  gameInfo,
  gameState,
  currency,
  stateRound,
  handleNotification,
  handleDeal,
  handleRaise,
  handleFold,
  handleNewBet,
  handleDealOut,
  stakesForSocket,
  audio,
  handleClearCards,
  handleShowResult,
  isError,
  handleIsFolded,
  winType,
  isFolded,
  dealOut,
}: // setNoAnimate,
FOOTER_PROPS) {
  const [stake, setstake] = useState<string>('0')
  const { precision } = gameInfo

  const [AAbonus, setAAbonus] = useState<string>(
    stakesForSocket.AAbonus === '0' ? 'AA' : stakesForSocket.AAbonus,
  )
  const [AAbonusHistory, setAAbonusHistory] = useState<string[]>([])

  const [ante, setante] = useState<string>(stakesForSocket.ante || '0')
  const [anteHistory, setanteHistory] = useState<string[]>(['0'])

  useEffect(() => {
    setAAbonus(
      stakesForSocket.AAbonus === '0'
        ? 'AA'
        : formatThousandWithDecimals(stakesForSocket.AAbonus),
    )
    setante(formatThousandWithDecimals(stakesForSocket.ante) || '0')
  }, [stakesForSocket])

  const [active, setActive] = useState('ante')

  const handleActive = (s: string) => setActive(s)

  const [raiseVal, setRaiseVal] = useState<string>('0')

  const { totalWin, raise, aa } = stateRound
  const [aaWin, setAA] = useState(aa.win)
  const [showAAWin, setAAWin] = useState(false)

  useEffect(() => {
    const aaWin = Number(aa.win)
    if (aaWin > 0) {
      setAA(aa.win)
      setAAWin(true)
    } else setAAWin(false)
  }, [aa.win])

  const text = useText(
    active,
    AAbonus,
    ante,
    aaWin,
    showAAWin,
    gameState,
    winType,
    currency,
    totalWin,
    isFolded,
    precision,
  )

  const handleChip = (c: string) =>
    heplerChip(
      c,
      active,
      setante,
      setAAbonus,
      handleNotification,
      currency,
      gameInfo.maxBet,
      precision,
    )

  useUpdateHistory(AAbonus, setAAbonusHistory)

  useUpdateHistory(ante, setanteHistory)

  useEffect(() => {
    setstake(sumAA(gameInfo.maxBet, AAbonus, ante, precision))
  }, [AAbonus, ante, gameInfo])

  useEffect(() => {
    gameState !== 0 && gameState !== 1 && parseFloat(raise.bet) > 0 && !isError
      ? setRaiseVal(formatThousandWithDecimals(+raise.bet))
      : setRaiseVal('0')
  }, [gameState, raise.bet, isError])

  useEffect(() => {
    // setstake('0')
  }, [isError])

  const handleUndo = () => {
    helperUndo(
      active,
      setante,
      anteHistory,
      setanteHistory,
      setAAbonus,
      AAbonusHistory,
      setAAbonusHistory,
    )
  }

  const clearStake = () => {
    helperClearStake(
      active,
      setante,
      setanteHistory,
      setAAbonus,
      setAAbonusHistory,
    )
  }

  return (
    <>
      <Text text={text} gameState={gameState} dealOut={dealOut} />
      <PositionsWrapper
        audio={audio}
        ante={ante}
        AAbonus={AAbonus}
        raise={raiseVal}
        active={active}
        handleActive={handleActive}
        gameState={gameState}
        precision={precision}
      />
      <ChipSwiper
        gameInfo={gameInfo}
        handleChip={handleChip}
        gameState={gameState}
        audio={audio}
      />
      <BetButtons
        audio={audio}
        stake={stake}
        ante={ante}
        AAbonus={AAbonus}
        currency={currency}
        active={active}
        gameState={gameState}
        handleUndo={handleUndo}
        handleDeal={handleDeal}
        handleRaise={handleRaise}
        handleFold={handleFold}
        handleNewBet={handleNewBet}
        handleDealOut={handleDealOut}
        handleActive={handleActive}
        handleClearCards={handleClearCards}
        handleShowResult={handleShowResult}
        clearStake={clearStake}
        handleIsFolded={handleIsFolded}
        isError={isError}
      />
    </>
  )
}

export default Footer
